import { FlexColumn, FlexRoot, FlexRow } from "./parts";

const Flex = Object.assign(FlexRoot, {
  Column: FlexColumn,
  Row: FlexRow,
});

export default Flex;
